<div>
    <header class="page-heading">
        <div class="container">
            <h1>Contact</h1>
            <p>If you would like to find out more out the Sinirji System or any of our other products or services we love to
                hear from you.</p>
        </div>
    </header>

    <div class="container">
        <h2>
            <i class="fa fa-comments-o"></i> Feedback &amp; Suggestions</h2>

        <p>
            <strong>By Email:</strong> info@sinirji.com</p>

        <h2>
            <i class="fa fa-phone"></i> Phone Contact Us By Phone</h2>

        <p>
            <strong>By Phone (Toll Free):</strong> 1-(844) 335-5590</p>

        <p>
            <strong>By Phone (US):</strong> (617) 500-3981</p>

        <p>
            <strong>By Phone (Canada):</strong> (647) 800-0377</p>

        <p>
            <strong>By Fax:</strong> (647) 776-7605</p>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/components/contact/contact.component.html